import { render, staticRenderFns } from "./InvoiceOrderList.vue?vue&type=template&id=984ea128&scoped=true&"
import script from "./InvoiceOrderList.vue?vue&type=script&lang=js&"
export * from "./InvoiceOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984ea128",
  null
  
)

export default component.exports